import Instance from "../../../Axios";

// New Actions for the app

const EditClientById = (yData, id) => async (dispatch) => {
  await Instance()
    .put(`/plus/adesoes/clients/profiles/${id}`, { yData })
    .then(({ data }) => {
      dispatch({ type: "EDIT_CLIENT_BY_ID", payload: data });
    })
    .catch((err) => {
      console.log(err);
    });
};

export default EditClientById;
